import { FC, SVGAttributes } from 'react';

const ListinRight: FC<React.PropsWithChildren<React.PropsWithChildren<SVGAttributes<SVGElement>>>> = ({ ...props }) => {
  return (
    <svg width="18" height="24" viewBox="0 0 18 24" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.32238 5.22257C8.8928 5.65215 8.8928 6.34863 9.32238 6.77821L14.5446 12.0004L9.32238 17.2226C8.8928 17.6522 8.8928 18.3486 9.32238 18.7782C9.75195 19.2078 10.4484 19.2078 10.878 18.7782L16.878 12.7782C17.3076 12.3486 17.3076 11.6521 16.878 11.2226L10.878 5.22257C10.4484 4.793 9.75195 4.793 9.32238 5.22257Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ListinRight;
